import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar } from '../../components/Navbar';

import EventBG from '../../assets/EventBG.jpg';
import { EventList } from '../../components/EventList';

const EventPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-amber-100">
      <Navbar src={EventBG} pageName={t('eventsPage.pageTitle')} pageText={''} />
      <EventList />
    </div>
  );
};

export { EventPage };
